import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\GetEnaosConfigByItemIdController::__invoke
* @see app/Http/Controllers/Item/GetEnaosConfigByItemIdController.php
* @route '/api/item/{item}/enaos/item-for-sales'
*/
const GetEnaosConfigByItemIdController = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetEnaosConfigByItemIdController.url(args, options),
    method: 'get',
})

GetEnaosConfigByItemIdController.definition = {
    methods: ["get","head"],
    url: '/api/item/{item}/enaos/item-for-sales',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\GetEnaosConfigByItemIdController::__invoke
* @see app/Http/Controllers/Item/GetEnaosConfigByItemIdController.php
* @route '/api/item/{item}/enaos/item-for-sales'
*/
GetEnaosConfigByItemIdController.url = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
    }

    return GetEnaosConfigByItemIdController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\GetEnaosConfigByItemIdController::__invoke
* @see app/Http/Controllers/Item/GetEnaosConfigByItemIdController.php
* @route '/api/item/{item}/enaos/item-for-sales'
*/
GetEnaosConfigByItemIdController.get = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetEnaosConfigByItemIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\GetEnaosConfigByItemIdController::__invoke
* @see app/Http/Controllers/Item/GetEnaosConfigByItemIdController.php
* @route '/api/item/{item}/enaos/item-for-sales'
*/
GetEnaosConfigByItemIdController.head = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetEnaosConfigByItemIdController.url(args, options),
    method: 'head',
})

export default GetEnaosConfigByItemIdController